
<div class="p-grid surveyGrid">
  <div class="p-col-md-fixed surveyLeftBorder1 bigScreenOnly"></div>
  <div class="p-col-md-fixed surveyLeftBorder2 bigScreenOnly"></div>
  <div class="p-col-fixed surveyLeftBorder3 bigScreenOnly surveyQuestions">
    <app-survey-header></app-survey-header>
  </div>
  <div class="p-col surveyQuestions"><app-survey-content></app-survey-content></div>
</div>
